<div *ngIf="product as productDetail">
    <div class="mb:pb-24">
        <vsf-section-nav-menu
            [isMobile]="isMobile"
            [showTopNav]="showTopNav"
            [isHeaderFloating]="isHeaderFloating"
            [withHeaderMessage]="withHeaderMessage"
            [navigationMenu]="navigationMenu"
            (navItemClicked)="scrollToSection($event)"
        ></vsf-section-nav-menu>
        <h1 *ngIf="h1CustomText && h1StyleMode !== 'sr-only'"
            [innerHTML]="h1CustomText | safeHtml"
            [ngStyle]="h1CustomStyles"
            class="page-h1-heading px-4 py-2 text-3xl font-bold"></h1>
        <h1 *ngIf="h1CustomText && h1StyleMode === 'sr-only'"
            class="sr-only">{{ h1CustomText }}</h1>
        <ng-container *ngIf="pagecomponentList.length > 0">
            <div *ngFor="let component of pagecomponentList; let i = index" [ngStyle]="layoutOrder[i].styles" [id]="component.sectionId">
                <ng-container *ngIf="component.type === 'product-info-section'; else otherComponent">
                    <div *ngIf="selectedVariant" class="pb-[60px]">
                        <vsf-product-info
                            [product]="productDetail"
                            [selectedVariant]="selectedVariant"
                            [isMobile]="isMobile"
                            [arrowType]="pdpAssetsArrowType"
                            [linePadding]="layoutOrder[i].linePadding"
                            (variantChanged)="onVariantChange($event)"
                            (printTemplateChanged)="onTemplateChanged($event)"
                            (shopNowBannerVisibilityChange)="onShopNowBannerVisibilityChange($event)"
                            (allCustomizationOptionsChanged)="onCustomizationOptionsChanged($event)"
                            (messageValuesChanged)="onMessageValuesChanged($event)"
                            (selectedPaidOptionValuesChanged)="onSelectedPaidOptionValuesChanged($event)"
                        >
                        </vsf-product-info>
                    </div>
                </ng-container>
                <ng-template #otherComponent>
                    <vsf-page-component
                        [pageComponent]="component"
                        [linePadding]="layoutOrder[i].linePadding"
                        [horizontalPadding]="layoutOrder[i].horizontalPadding"
                        [sectionRoundedClass]="layoutOrder[i].roundedClass"
                        [isMobile]="isMobile"
                        [sellerChannelId]="sellerChannelId"
                        [pdpAssetsArrowType]="pdpAssetsArrowType"
                        [pageFullWidth]="layoutOrder[i].pageFullWidth ?? false"
                        [sectionMaxHeight]="layoutOrder[i].sectionMaxHeight || ''"
                        [isPageHeading]="i === h1PageHeadingIndex"
                        [h1StyleMode]="h1StyleMode">
                    </vsf-page-component>
                </ng-template>
            </div>
        </ng-container>
        <div *ngIf="productDetail.customFields.ProductDisclaimer && isMobile">
            <div class="border rounded shadow p-4">
                <span class="disclaimer-html rich-text-content" [innerHtml]="productDetail.customFields.ProductDisclaimer | safeHtml"></span>
            </div>
        </div>
        <hr>
    </div>
    <div *ngIf="isMobile" [style.z-index]="9" class="fixed bottom-0 left-0 right-0 bg-white shadow-lg">
        <vsf-product-shop-now-banner
            [product]="productDetail"
            [selectedVariant]="selectedVariant"
            [selectedPrintTemplate]="selectedPrintTemplate"
            [isMobile]="isMobile"
            [inStock]="inStock"
            [mobileBuyBannerType]="mobileBuyBannerType"
            [allCustomizationOptions]="allCustomizationOptions"
            [messageValues]="messageValues"
            [selectedPaidOptionValues]="selectedPaidOptionValues"
            >
        </vsf-product-shop-now-banner>
    </div>
    <div *ngIf=" (isMobile === false) && showFixedBanner"
        [ngStyle]="{'top.px': shopNowBannerTopOffset }"
        class="fixed-banner fixed left-0 right-0 bg-white shadow-lg">
        <vsf-desktop-shop-now-banner
            [product]="productDetail"
            [selectedVariant]="selectedVariant"
            [selectedPrintTemplate]="selectedPrintTemplate"
            [isMobile]="isMobile"
            [inStock]="inStock"
            [allCustomizationOptions]="allCustomizationOptions"
            [messageValues]="messageValues"
            [selectedPaidOptionValues]="selectedPaidOptionValues"
            >
        </vsf-desktop-shop-now-banner>
    </div>
</div>
